import { useHistory } from 'react-router-dom';
import { useEffect } from 'react';
import { RegistrationWizard } from '@/components/wizards/RegistrationWizard';
import { useAuthStore } from '@/stores/useAuthStore';
import { setSeo, resetSeo } from '@/lib/seo';

export function RegisterPage() {
  const history = useHistory();
  const setRoleSelection = useAuthStore((s) => s.setRoleSelection);
  const email = useAuthStore((s) => s.profile?.email);

  useEffect(() => {
    setSeo({ robots: 'noindex, nofollow' });
    return () => resetSeo();
  }, []);

  return (
    <RegistrationWizard
      onComplete={(role) => {
        setRoleSelection(role ?? 'candidate');
        history.replace(`/verify-email?email=${encodeURIComponent(email ?? '')}`);
      }}
    />
  );
}
